import classNames from "classnames";
import React from "react";

export default function ({ variant, percent, firstNumber, secondNumber }) {
  return (
    <div
      className={classNames("progress-line", { inner: variant === "inner" })}
    >
      <div className="progress-line__wrapper">
        <div
          className="progress-line__indicator"
          style={{ width: `${percent}%` }}
        ></div>
      </div>
      <div
        className={classNames("progress-line__dsp", {
          ocolor: variant === "inner",
        })}
      >
        <span className="progress-line__number progress-line__number_firstNumber">
          {firstNumber}
        </span>
        {variant === "inner" && (
          <span className="progress-line__separator">/</span>
        )}
        <span className="progress-line__number progress-line__number_secondNumber">
          {secondNumber}
        </span>
      </div>
    </div>
  );
}
